<template>
  <v-list-item class="e-list-item" v-bind="$attrs" @click="$emit('click', $event)">
    <v-list-item-avatar v-if="showAvatar">
      <slot name="avatar">
        <e-avatar v-bind="_avatarOptions" />
      </slot>
    </v-list-item-avatar>

    <v-list-item-content>
      <slot>
        <slot name="title">
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </slot>

        <slot name="description">
          <v-list-item-subtitle>
            {{ item.description }}
          </v-list-item-subtitle>
        </slot>
      </slot>
    </v-list-item-content>

    <v-list-item-action v-if="showAction && ($slots.action || item.chip)" class="e-list-item__actions">
      <slot name="action">
        <e-chip v-if="item.chip" v-bind="_chipOptions" :label="false">
          {{ item.chip.label }}
        </e-chip>
      </slot>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import {
  VListItem,
  VListItemAvatar,
  VListItemContent,
  VListItemTitle,
  VListItemSubtitle,
  VListItemAction,
} from 'vuetify/lib'
import { EChip } from '../EChip'
import { EAvatar } from '../EAvatar'

export default {
  name: 'EListItem',

  components: {
    VListItem,
    VListItemAvatar,
    VListItemContent,
    VListItemTitle,
    VListItemSubtitle,
    VListItemAction,
    EChip,
    EAvatar,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },

    showAvatar: {
      type: Boolean,
      default: true,
    },

    showAction: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    _avatarOptions() {
      return {
        large: true,
        ...(this.item.avatar || {}),
      }
    },

    _chipOptions() {
      return {
        small: true,
        ...(this.item.chip || {}),
      }
    },
  },
}
</script>
